// Better Auth browser client for the cloud web SPA.
//
// Same-origin: the SPA and the auth handler (/api/auth/*) are served by ONE
// Worker (MA-286 §2), so baseURL is omitted — the client defaults to the current
// origin + the /api/auth base path, matching workers/cloud's route mount.
//
// Plugins mirror the server (workers/cloud/src/auth.ts):
//   - passkeyClient   → the strong-auth credential (WebAuthn ceremony)
//   - emailOTPClient  → optional sign-in / account bootstrap via a one-time code
// Social OAuth (GitHub/Google) needs NO client plugin — authClient.signIn.social()
// is core. Password auth is intentionally absent (disabled server-side — passwords
// are the breach surface).
import { createAuthClient } from 'better-auth/react';
import { passkeyClient } from '@better-auth/passkey/client';
import { emailOTPClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
  plugins: [passkeyClient(), emailOTPClient()],
});
